export default __webpack_public_path__ + "static/media/f2.02669bc2.png";